module.exports = __webpack_public_path__ + "static/assets/92b39469032012e7920703bdaabf0e35.png";